<template>
  <div :class="[
    $style.component,
    'animate__animated',
    'animate__zoomIn'
  ]">
    <div :class="$style.content">
      <div>
        <slot />
      </div>
    </div>
  </div>
 </template>

<script>
export default {
  setup () {

  },
}
</script>

<style module lang="scss">
.component {
  box-sizing: border-box;
  position: fixed;
  left: 0px;
  top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  text-align: center;
  color: white;
  z-index: 11;
}

.content {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  padding: 40px 20px;
  background: transparent linear-gradient(180deg, #5B4E98 0%, #F59DB2 100%) 0% 0% no-repeat padding-box;
  overflow-x: hidden;
  overflow-y: auto;

  @include media.query($from: 1024) {
    width: auto;
    height: auto;
    max-height: 100%;
    padding: 120px 80px;
  }
}
</style>
